// Imported labels are suggestions, never new categories. Return the owner's
// exact stored names, including case, and never fall back to starter defaults.
export function matchImportedCategories(suggestions, categories) {
  const allowed = Array.isArray(categories)
    ? categories.map(category => category?.name).filter(name => typeof name === 'string' && name.trim())
    : [];
  const values = typeof suggestions === 'string' ? [suggestions] : Array.isArray(suggestions) ? suggestions : [];
  const selected = [];
  for (const value of values) {
    if (typeof value !== 'string') continue;
    const label = value.trim();
    const match = allowed.find(name => name === label)
      ?? allowed.find(name => name.trim().toLowerCase() === label.toLowerCase());
    if (match !== undefined && !selected.includes(match)) selected.push(match);
  }
  return selected;
}